// src/pages/jobs/ManageJobsList.js
import React, { useEffect, useState } from 'react'
import { useGlobal } from '../../context/GlobalContext'
import api from '../../services/api'
import { useNavigate } from 'react-router-dom'

function ManageJobsList() {
  const [jobs, setJobs] = useState([])
  const [filter, setFilter] = useState('active')
  const { showLoading, hideLoading, showMessage } = useGlobal()
  const navigate = useNavigate()

  async function loadJobs(statusValue) {
    try {
      showLoading()
      const res = await api.get(`/manage-jobs?status=${statusValue}`)
      if (res.data && res.data.jobs) setJobs(res.data.jobs)
    } catch {
      showMessage('Error loading jobs', 'error')
    } finally {
      hideLoading()
    }
  }

  useEffect(() => {
    loadJobs(filter)
  }, [filter])

  async function markComplete(jobId) {
    try {
      showLoading()
      await api.post(`/manage-jobs/mark-complete/${jobId}`)
      showMessage('Job marked as complete', 'success')
      loadJobs(filter)
    } catch {
      showMessage('Error marking job as complete', 'error')
    } finally {
      hideLoading()
    }
  }

  async function deleteJob(jobId) {
    try {
      showLoading()
      await api.delete(`/manage-jobs/${jobId}`)
      showMessage('Job deleted', 'success')
      loadJobs(filter)
    } catch {
      showMessage('Error deleting job', 'error')
    } finally {
      hideLoading()
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>Manage Jobs</h2>
      <select value={filter} onChange={(e) => setFilter(e.target.value)}>
        <option value="active">Active</option>
        <option value="completed">Completed</option>
        <option value="all">All</option>
      </select>
      <table style={{ width: '100%', marginTop: '20px', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Title</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Desc</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Status</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => (
            <tr key={job._id}>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{job.plainTitle}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{job.plainDescription}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                {job.jobCompletedAt ? 'Completed' : 'Active'}
              </td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                <button onClick={() => navigate(`/manage-jobs/edit/${job._id}`)} style={{ marginRight: '10px' }}>
                  Edit
                </button>
                {!job.jobCompletedAt && (
                  <button onClick={() => markComplete(job._id)} style={{ marginRight: '10px' }}>
                    Mark Complete
                  </button>
                )}
                <button onClick={() => deleteJob(job._id)}>Delete</button>
              </td>
            </tr>
          ))}
          {jobs.length === 0 && (
            <tr>
              <td
                colSpan="4"
                style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}
              >
                No jobs found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <button onClick={() => navigate('/create-job')} style={{ marginTop: '20px' }}>
        Create New Job
      </button>
    </div>
  )
}

export default ManageJobsList